import React, { useState } from 'react'
import { withRouter } from 'react-router-dom'
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap'
import { ReactComponent as User } from '../../../../assets/images/scouts/user.svg'
import { ReactComponent as Settings } from '../../../../assets/images/scouts/setting.svg'
import { ReactComponent as LogOut } from '../../../../assets/images/scouts/logout.svg'
import './ProfileToggle.scss'
import { Avatar } from 'antd'
import { fetchEducationUserLogout } from '../../../../redux/auth/authActions'
import { useDispatch } from 'react-redux'

const ProfileToggle = props => {
  const dispatch = useDispatch()
  const { profileData } = props
  const [activeProfile, setActiveProfile] = useState(false)
  const [activeCompanyInfo, setActiveCompanyInfo] = useState(false)

  const handleProfileClick = () => {
    setActiveProfile(!activeProfile)
  }

  const handleCompanyInfoClick = () => {
    setActiveCompanyInfo(!activeCompanyInfo)
    props.history.push('/education/get-accredited/profile')
  }

  const handleProfileSettingClick = () => {
    setActiveCompanyInfo(!activeCompanyInfo)
    props.history.push('/education/get-accredited/setting')
  }

  const onLogout = async () => {
    await dispatch(fetchEducationUserLogout('series65'))
    // localStorage.clear()
    localStorage.removeItem('series65_token')
    props.history.replace('/education/get-accredited/login')
  }

  return (
    <div className="custom-education-dropdown ml-2">
      <Dropdown isOpen={activeProfile} toggle={handleProfileClick}>
        <DropdownToggle>
          <Avatar className="education-avatar-wrap" src={profileData?.profile_pic}>
            {profileData?.first_name?.[0]?.toUpperCase()}
          </Avatar>
        </DropdownToggle>
        <DropdownMenu right>
          <DropdownItem onClick={handleCompanyInfoClick}>
            <User />
            Profile
          </DropdownItem>
          <DropdownItem onClick={handleProfileSettingClick}>
            <Settings />
            Settings
          </DropdownItem>
          <DropdownItem onClick={onLogout}>
            <LogOut />
            Logout
          </DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  )
}

export default withRouter(ProfileToggle)
